import type { ReactNode } from "react";

interface HeroSceneProps {
  title: string;
  chip: string;
  // The scene is a picture of the product, so it's exposed as one image
  // with this description rather than as its inner text.
  ariaLabel: string;
  children: ReactNode;
}

// Warm gradient card used as a hero illustration: a small title + chip row
// over whatever mock UI the page puts inside (the preview's `.vscene`).
const HeroScene = ({ title, chip, ariaLabel, children }: HeroSceneProps) => (
  <div
    role="img"
    aria-label={ariaLabel}
    className="relative flex flex-col justify-center gap-4 rounded-[28px] bg-vscene p-5 text-ink sm:p-8 lg:min-h-[400px]"
  >
    <div className="mb-2.5 flex items-center justify-between gap-2.5">
      <span className="text-[15px] font-bold">{title}</span>
      <span className="inline-block rounded-full bg-paper px-2.5 py-[3px] text-xs font-semibold text-primary">
        {chip}
      </span>
    </div>
    {children}
  </div>
);

export default HeroScene;
